/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

/** Remote settings key for the keep-account recovery popup during sign-in. Value `1` is on, `0` is off. */
export const ACCOUNT_RECOVERY_SETTINGS = {
  enabled: 'enable_account_recovery',
} as const;

/** SSO error code returned when the user has a pending soft-delete. */
export const USER_SCHEDULED_FOR_DELETION =
  'USER_SCHEDULED_FOR_DELETION' as const;

/** Passwordless body `status` to cancel a pending deletion and continue login. */
export const CANCEL_DELETION_STATUS = 'cancel_deletion' as const;
